import React, { useEffect, useState } from "react";
import API from "../services/api";

function ManageEpapers() {
  const [epapers, setEpapers] = useState([]);
  const [editing, setEditing] = useState(null);

  useEffect(() => {
    fetchEpapers();
  }, []);

  const fetchEpapers = async () => {
    const res = await API.get("/epapers/all");
    setEpapers(res.data);
  };

  const deletePaper = async (id) => {
    if (window.confirm("Are you sure you want to delete this edition?")) {
      await API.delete(`/epapers/delete/${id}`);
      fetchEpapers();
    }
  };

  const editPaper = (paper) => {
    let formattedDate = "";
    if (paper.publish_date) {
      formattedDate = new Date(paper.publish_date).toISOString().split("T")[0];
    }
    setEditing({ ...paper, publish_date: formattedDate });
  };

  return (
    <div className="max-w-6xl mx-auto mt-6">
      
      {/* HEADER SECTION */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Manage Editions</h2>
        <a href="/admin/upload" className="bg-news-red hover:bg-red-700 text-white px-4 py-2 rounded text-sm font-semibold transition">
          + Add New Edition
        </a>
      </div>

      {/* EDIT MODAL/BOX */}
      {editing && (
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8 max-w-2xl">
          <h3 className="text-lg font-bold text-news-blue mb-4">Edit Edition: {editing.title}</h3>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">Title</label>
              <input
                type="text"
                value={editing.title}
                onChange={(e) => setEditing({ ...editing, title: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-1 focus:ring-news-blue outline-none"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">Edition</label>
              <input
                type="text"
                value={editing.edition}
                onChange={(e) => setEditing({ ...editing, edition: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-1 focus:ring-news-blue outline-none"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">Publish Date</label>
              <input
                type="date"
                value={editing.publish_date}
                onChange={(e) => setEditing({ ...editing, publish_date: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-1 focus:ring-news-blue outline-none"
              />
            </div>
          </div>

          <div className="flex justify-end space-x-2">
             <button
               onClick={() => setEditing(null)}
               className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded text-sm font-semibold transition"
             >
               Cancel
             </button>
             <button
              onClick={async () => {
                await API.put(`/epapers/update/${editing.id}`, editing);
                setEditing(null);
                fetchEpapers();
              }}
               className="bg-news-blue hover:bg-blue-800 text-white px-4 py-2 rounded text-sm font-semibold transition"
             >
               Save Changes
             </button>
          </div>
        </div>
      )}

      {/* DATA TABLE */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider border-b border-gray-200">
              <th className="p-4 font-semibold">Title</th>
              <th className="p-4 font-semibold">Edition</th>
              <th className="p-4 font-semibold">Publish Date</th>
              <th className="p-4 font-semibold text-center">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {epapers.length === 0 && (
               <tr><td colSpan="4" className="p-6 text-center text-gray-500">No epapers found. Upload one to get started.</td></tr>
            )}
            {epapers.map((paper) => (
              <tr key={paper.id} className="hover:bg-gray-50 transition">
                <td className="p-4 text-sm font-medium text-gray-800">{paper.title}</td>
                <td className="p-4 text-sm text-gray-600">
                   <span className="bg-blue-100 text-news-blue py-1 px-2 rounded text-xs font-semibold">{paper.edition}</span>
                </td>
                <td className="p-4 text-sm text-gray-600">
                  {paper.publish_date ? new Date(paper.publish_date).toLocaleDateString() : ""}
                </td>
                <td className="p-4 text-sm font-medium text-center space-x-3 text-nowrap">
                  <button
                    onClick={() => editPaper(paper)}
                    className="text-news-blue hover:text-blue-800 transition"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => deletePaper(paper.id)}
                    className="text-red-500 hover:text-red-700 transition"
                  >
                    Delete
                  </button>
                  <a
                    href={`/viewer/${paper.id}`}
                    target="_blank" rel="noreferrer"
                    className="text-gray-500 hover:text-gray-800 transition pl-2 border-l border-gray-300"
                  >
                    View
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default ManageEpapers;